import { Component, ElementRef, HostListener, OnInit, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import { Config } from '../../../app/config';
import { LayoutService } from '../../services/layout.service';
import { SessionService } from '../../../app/services/session.service';
import { Router } from '@angular/router';
import { SubDomainDesignService } from '@eadsysteme/portalsettingclient-v1';
import { DesignUtil } from 'src/app/services/design-util.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
	selector: 'vex-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective],
})
export class FooterComponent implements OnInit {
	private readonly layoutService = inject(LayoutService);
	private readonly sessionService = inject(SessionService);
	private readonly designUtil = inject(DesignUtil);
	private readonly subDomainDesignService = inject(SubDomainDesignService);
	private readonly router = inject(Router);

	/* @Input() customTemplate: TemplateRef<any>;
   icShoppingBasket = icShoppingBasket;*/
	version = Config.VERSION;
	public _layoutService: LayoutService;
	showLegalNotice = false;
	showPrivacy = false;
	companyType = '';
	flexWidth = '660px';
	readonly footer = viewChild<ElementRef>('footerDiv');
	readonly flexDiv = viewChild<ElementRef>('flexDiv');
	readonly privacyDiv = viewChild<ElementRef>('privacyDiv');
	readonly legalNoticeDiv = viewChild<ElementRef>('legalNoticeDiv');
	readonly versionDiv = viewChild<ElementRef>('versionDiv');

	constructor() {
		const layoutService = this.layoutService;

		this._layoutService = layoutService;
	}

	ngOnInit() {
		this.companyType = this.sessionService.getCompanyNameFromUrl();

		if (this.companyType) {
			this.showLegalNotice = this.designUtil.currentDesign()?.attributes[0]?.value !== '1';
			this.showPrivacy = this.designUtil.currentDesign()?.attributes[0]?.value !== '1';
		}
	}

	setFlexWidth() {
		const footerWidth = this.footer()?.nativeElement?.offsetWidth;
		let sideNavWidth;
		let randomSideNavWidthOffset;
		if (footerWidth >= 1280) {
			// This means, sidebar is shown
			sideNavWidth = this.sessionService.sideNavWidth;
			randomSideNavWidthOffset = 110;
		} else {
			sideNavWidth = 0;
			randomSideNavWidthOffset = 0;
		}
		const privacyWidth = this.privacyDiv()?.nativeElement?.offsetWidth;
		const legalNoticeWidth = this.legalNoticeDiv()?.nativeElement?.offsetWidth;
		const versionWidth = this.versionDiv()?.nativeElement?.offsetWidth;
		this.flexWidth = footerWidth - sideNavWidth - randomSideNavWidthOffset - privacyWidth - legalNoticeWidth - versionWidth + 'px';
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.setFlexWidth();
	}

	goToLegalNotice() {
		this.router.navigate(['/legal-notice']);
	}

	goToPrivacy() {
		this.router.navigate(['/privacy']);
	}
}
